// extracted by mini-css-extract-plugin
module.exports = {"content":"style_content__1FT2Z","destructive-title":"style_destructive-title__2MGcB"};